export default {
  data() {
    return {
      checkInForm: this.$inertia.form({
        location_id: null
      }),
      checkOutForm: this.$inertia.form({
        location_id: null,
        customer_ids: []
      })
    }
  },

  methods: {
    checkInCustomer(customerId, onSuccess = null, onError = null) {
      this.checkInForm.post(route('customers.check-in', { customer: customerId }), {
        errorBag: 'checkInCustomer',
        onSuccess: (response) => {
          if (onSuccess) {
            onSuccess()
          }
        },
        onError: (response) => {
          if (onError) {
            onError(response)
          }
        }
      })
    },
    checkOutCustomer(customerId, onSuccess = null) {
      this.checkOutForm.customer_ids = [customerId]

      this.checkOutForm.post(route('customers.check-out'), {
        errorBag: 'checkOutCustomer',
        onSuccess: (response) => {
          if (onSuccess) {
            onSuccess()
          }
        }
      })
    },
    checkOutCustomers(customerIds, onSuccess = null) {
      this.checkOutForm.customer_ids = customerIds

      this.checkOutForm.post(route('customers.check-out'), {
        errorBag: 'checkOutCustomer',
        onSuccess: (response) => {
          if (onSuccess) {
            onSuccess()
          }
        }
      })
    }
  }
}
